import { useEffect, useState } from "react";
import { getAnonymousCalls, getLabList, getParsicUser, getVoipToken } from "../../../api/api"
import { UpdateParsicUsers } from "../../../redux/reducers/parsicUsersSlice"
import { useAppDispatch, useAppSelector } from "../../../redux/store/storehooks";
import { errorNotify, errorNotifyByErrorObject } from "../../../services/toast.notification";
import { Button, Col, ConfigProvider, Radio, RadioChangeEvent, Row, Space } from "antd";
import jalali_moment from 'jalali-moment';
import CustomTable from "../../../components/_common/Table";
import { ColumnsType } from "antd/lib/table";
import { DatePicker as DatePickerJalali, JalaliLocaleListener, useJalaliLocaleListener } from "antd-jalali";
import moment from 'moment'
import fa_IR from "antd/lib/locale/fa_IR";
import Spinner from "../../../components/_common/Spinner";
import { UpdateLabList } from "../../../redux/reducers/lablistSlice";
import { AssignLabDialog } from "./AssignLabDialog";

export interface InputProps {
    labId:any
  }

const AnonymousCalls = ({labId}:InputProps) => {

    const columns: ColumnsType<any> = [
        { title: 'آزمایشگاه ', dataIndex: 'customername', key: 'customername' },
        { title: 'شماره آزمایشگاه', dataIndex: 'callernumber', key: 'callernumber' },
        { title: 'شماره هدف ', dataIndex: 'targetnumber', key: 'targetnumber' },
        { title: 'تعداد ارجاع', dataIndex: 'DivertCount', key: 'DivertCount' },
        { title: 'تاریخ تماس', dataIndex: 'calldate', key: 'calldate' },
        { title: 'ساعت تماس', dataIndex: 'calltime', key: 'calltime' },
        { title: 'شخص', dataIndex: 'exten', key: 'exten' },
        { title: 'ارجاع', dataIndex: 'DivertRoute', key: 'DivertRoute' },
        {
            title: '', dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Space size="middle">
                    <a
                        href={"https://192.168.1.10/" + record.recordingfile}
                        download="Example-PDF-document"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Button type="primary" style={{ backgroundColor: "#00b7ff" }}
                            disabled={!permission} >دانلود فایل</Button>
                    </a>
                </Space>
            )
        },
        {
            title: '', dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Space size="middle">
                    <Button type="primary" onClick={()=>_assignLab(record.callernumber)} style={{ backgroundColor: "#00b7ff" }}
                        disabled={!permission} >اتصال به آزمایشگاه </Button>
                </Space>
            )
        }
    ];


    const [isLoading, setIsLoading] = useState(true);
    const [permission, setPermission] = useState(false);
    const [userList, setUserList] = useState<any[]>([]);
    const [radioVal, setRadioVal] = useState(0);
    const [voipLogs, setVoipLogs] = useState([]);
    const [firstDate, setFirstDate] = useState<any>(undefined);
    const [lastDate, setLastDate] = useState<any>(undefined);
    const [showAssignLabDialog, setShowAssignLabDialog] = useState(false);
    const [assignLabDialogPayload, setAssignLabDialogPayload] = useState({ callernumber: 0 });

    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();

    const _getParsicUser = () => {
        getParsicUser()
            .then((result: any) => {
                dispatch(UpdateParsicUsers({ parsicUsers: result.data.data }))

                setUserList(result.data.data)

                setIsLoading(false);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            })
    }

    const _assignLab = (num : number) =>{
        setShowAssignLabDialog(true)


        setAssignLabDialogPayload((values: any) => ({
            ...values,
            callernumber: num,
        }));
    }

    const _getVoipLogs = (fdate: any, ldate: any) => {
        setIsLoading(true);
        // getVoipToken()
        // .then((result) => {
        getAnonymousCalls(fdate, ldate)
            .then((result: any) => {
                let jsonResult = JSON.parse(result.data.data);
                let newList: any = [];
                jsonResult.map((item: any) => {
                    //let index: number = result.data.findIndex((x: { int_VoipExtension: any; }) => x.int_VoipExtension == item.exten);
                    let obj: any = myStore.parsicUsers.list.find((x: any) => x.int_VoipExtension == Number(item.exten));
                    let FullName: string = obj !== undefined ? obj.str_FullName : "";
                    newList.push(
                        {
                            ...newList,
                            rowid: item.rowid,
                            customername: item.customername,
                            callernumber: item.callernumber,
                            labid: item.labid,
                            calldate: jalali_moment(item.calldate).locale("fa").format("YYYY-MM-DD"),
                            calltime: item.calltime,
                            targetnumber: item.targetnumber,
                            billsec: item.billsec,
                            sumsec: item.sumsec,
                            exten: FullName,
                            DivertCount: item.DivertCount,
                            DivertRoute: item.DivertRoute,
                            UNIQUEID: item.UNIQUEID,
                            recordingfile: item.recordingfile
                        }
                    )
                })
                setVoipLogs(newList);

                setIsLoading(false);
                console.log(result.data);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

        // })
        // .catch((error) => {
        //     console.log(error);
        //     errorNotify(error.response.data.errorMessage, undefined, 5000)
        // })
    }

    const onChangeDatePicker = (dates: any, dateStrings: any, info: any) => {

        console.log(dates);
        if (!dateStrings) return;
        if (dateStrings.length < 2) return;
        if (dateStrings[0] === "") return;
        if (dateStrings[1] === "") return;

        setFirstDate(dates[0])
        setLastDate(dates[1])

        let fdate = jalali_moment.from(dates[0].format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
            .format('YYYY/MM/DD');
        let ldate = jalali_moment.from(dates[1].format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
            .format('YYYY/MM/DD');


        _getVoipLogs(fdate, ldate);
        //ExcelTaxInfo(dates[0].format('YYYY-MM-DD'),dates[1].format('YYYY-MM-DD'));

    }

    useEffect(() => {
        _getVoipLogs(moment().format("YYYY/MM/DD"), moment().format("YYYY/MM/DD"));
        _getParsicUser();

        if (myStore.auth.loginType === 'parsicuser') {
            myStore.auth.permission.map((item: any) => {
                if (item.pageName == 'Machine')
                    setPermission(item.isDetailAccess);
            });
        }
        else {
            setPermission(true);
        }
    }, []);


    return (<>
        {isLoading === false && (
            <>
                <div className="calender">
                    <ConfigProvider locale={fa_IR} direction="rtl">
                        <JalaliLocaleListener />
                        <DatePickerJalali.RangePicker value={[firstDate, lastDate]} onCalendarChange={(dates: any, dateStrings: any, info: any) => onChangeDatePicker(dates, dateStrings, info)} />
                    </ConfigProvider>
                </div>
                <Row>
                    <CustomTable columns={columns} data={voipLogs} isloading={isLoading}
                        permission={permission} />
                </Row>


                {showAssignLabDialog && (
                <AssignLabDialog
                    visible={showAssignLabDialog}
                    onSubmit={() => {console.log(true);}}
                    onCancel={() => { setShowAssignLabDialog(false); }}
                    payLoad={assignLabDialogPayload}
                    setShowDialog={(value) => setShowAssignLabDialog(value)}
                />
            )}
            </>

        )}
        {
            isLoading === true && (
                <Spinner />
            )
        }
    </>)
}

export default AnonymousCalls;